import { FaqEntity, PaginatedEntity } from '@core/entities';
import { Type } from 'class-transformer';

export class UserContentFaqList extends PaginatedEntity {
  @Type(() => FaqEntity)
  faqs: FaqEntity[];
}
